module.exports = __webpack_public_path__ + "img/seaspotter-background.5fdd9efd.jpg";